import React, { Component, useState, useRef, useEffect } from 'react';

import {
  // Navigate,
  useNavigate,
} from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import '../99_untils/i18n/';
// import SEOHelmet from '../99_untils/SEOHelmet';
import {
  Button, Container, Row, Col,
  // Card, CardBody, CardTitle, CardSubtitle, CardText 
} from 'reactstrap';

// import Swiper JS
// import { Virtual, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// import required modules
import { Pagination, Navigation } from 'swiper/modules';

import apiURLs from '../99_untils/apiURLs';

// import AppNavi from '../Navigation/Navigation';
import AppNavi from "../Navigation/NavigationBlink";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import './MiniGame.css';
// import stageSpotlight from './images/mini-game-stage-spotlight.png';

// import minaPoseIdol01 from '../images/idols/Mina_1_thumb.png';
// import chaeyoungPoseIdol01 from '../images/idols/Chaeyoung_1_thumb.png';
// import dahyunPoseIdol01 from '../images/idols/Dahyun_1_thumb.png';
// import jeongyeonPoseIdol01 from '../images/idols/Jeongyeon_1_thumb.png';
// import jihyoPoseIdol01 from '../images/idols/Jihyo_1_thumb.png';
// import momoPoseIdol01 from '../images/idols/Momo_1_thumb.png';
// import nayeonPoseIdol01 from '../images/idols/Nayeon_1_thumb.png';
// import sanaPoseIdol01 from '../images/idols/Sana_1_thumb.png';
// import tzuyuPoseIdol01 from '../images/idols/Tzuyu_1_thumb.png';


import BPPoseIdol01 from '../images/idols/blackpink_01_thumb.png';
import jenniePoseIdol01 from '../images/idols/jennie_01.png';
import jisooPoseIdol01 from '../images/idols/jisoo_01.png';
import lisaPoseIdol01 from '../images/idols/lisa_01.png';
import rosePoseIdol01 from '../images/idols/rose_01.png';



export default function MiniGameSelect(props) {
  // console.log("MiniGameSelect constructor started ")
  const isMountedRef = useRef();
  // const canvasRef = useRef();
  const titleScoreWrapRef = useRef();
  const { t } = useTranslation();

  const { i18n } = useTranslation();
  let curLang = i18n.language; 
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [idolSelected, setIdolSelected] = useState(0);
  const [idolNameFocus, setIdolNameFocus] = useState(0);

  const [idolNameSong, setIdolNameSong] = useState([
    'JUMP',
    'LALISA',
    'APT.',
    'like JENNIE',
    'FLOWER',
  ]);
  
  const [idolNameZh, setIdolNameZh] = useState([
    'Blackpink',
    'Lisa ZH',
    'Rosé ZH',
    'Jennie ZH',
    'Jisoo ZH',
  ]);


  const [miniGameLeaderData, setMiniGameLeaderData] = useState([]);

  const [swiperRef, setSwiperRef] = useState(null);



  const playBtnOnClick = () => {
    const result = Object.values(miniGameLeaderData[idolNameFocus]);
    setIdolSelected(result)
// memberId
// console.log('MiniGameSelect playBtnOnClick miniGameLeaderData.memberId: ' + miniGameLeaderData[idolNameFocus].memberId);
    navigate(`/${curLang}/minigameplay?id=${miniGameLeaderData[idolNameFocus].memberId}`);
    // navigate(`/${curLang}/minigameplay?id=${idolNameFocus}`);
  }


  const matchIdolPoseImg = (tarStr) => {
      const namePrefix = tarStr ? String(tarStr).slice(0, 4) : '';
      switch (namePrefix) {
          case 'lisa': return lisaPoseIdol01;
          case 'rose': return rosePoseIdol01;
          case 'jenn': return jenniePoseIdol01;
          case 'jiso': return jisooPoseIdol01;
          default: return BPPoseIdol01; // Fallback to Mina
      }
  }



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(apiURLs.getLeaderboardDataURL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(window.authTokenData ? { 'Authorization': `Bearer ${window.authTokenData}` } : {})
          }
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();

        if (isMountedRef.current) { // Only update state if the component is still mounted

          const sortedLeaderByScore = [...result.entries].sort((a, b) => b.score - a.score);
          setMiniGameLeaderData(sortedLeaderByScore);
          // setMiniGameLeaderData([
          //     {
          //         "memberId": "lisa",
          //         "name": "Lisa",
          //         "score": 7
          //     },
          //     {
          //         "memberId": "rose",
          //         "name": "Rosé",
          //         "score": 40032
          //     },
          //     {
          //         "memberId": "jennie",
          //         "name": "Jennie",
          //         "score": 0
          //     },
          //     {
          //         "memberId": "jisoo",
          //         "name": "Jisoo",
          //         "score": 0
          //     },
          //     {
          //         "memberId": "jisoo",
          //         "name": "Jisoo",
          //         "score": 0
          //     }
          // ]);
          

          console.log('MiniGameSelect fetchData result')
          console.log(result.entries)
          console.log(sortedLeaderByScore)

        }
      } catch (error) {
        //   setError(error);
        // console.log('fetchData error')
      } finally {
        // console.log('fetchData loading finished ')
        //   setLoading(false);
      }
    };

    fetchData();


    // Cleanup function: runs when the component unmounts
    return () => {
      
    };
  }, []); // Empty dependency array means this runs once on mount

  useEffect(() => {

    isMountedRef.current = true;

    // const handleResize = () => {

    //   targetHeight = window.innerHeight;
    //   targetWidth = window.innerWidth;
    // };

    // handleResize();

    // window.addEventListener("resize", handleResize);

    return () => {
      isMountedRef.current = false;
      // window.removeEventListener("resize", handleResize);
      // console.log("MiniGame unmount")

    };
  }, []);


  return (

    <div className='mini-game-select-play-wrap'>
      {/* <SEOHelmet 
          titleKey="metaTitleMiniGameSelect" 
          descriptionKey="metaDescriptionMiniGameSelect" 
          canonicalPath={`/${curLang}/minigameselect`}
      /> */}
      <AppNavi colorWhiteLogo={true} />
      <div className="mini-game-idol-dance-bg-wrap">
        {/* <div className='mini-game-idol-dance-bg-spotlight'>
          <img className="" src={stageSpotlight} />
        </div> */}
      </div>

      <div ref={titleScoreWrapRef} className="mini-game-play-title-score-wrap">
        <Container>
          <Row className=''>
            <Col className="">

              <h5 className='margin-bot-10'>
                {/* {t('miniGameSelectTitle')} */}
                {idolNameSong[(() => {
                    switch (String(miniGameLeaderData[idolNameFocus] && miniGameLeaderData[idolNameFocus].memberId).slice(0, 4)) {
                        case 'lisa': return 1;
                        case 'rose': return 2;
                        case 'jenn': return 3;
                        case 'jiso': return 4;
                        default: return 0; // Fallback to Blackpink
                    } })()]}
                </h5>
              <h2 className='text-uppercase color-text-pink'>
                {curLang === 'zh-HK' ? 
                idolNameZh[(() => {
                    switch (String(miniGameLeaderData[idolNameFocus] && miniGameLeaderData[idolNameFocus].memberId).slice(0, 4)) {
                        case 'lisa': return 1;
                        case 'rose': return 2;
                        case 'jenn': return 3;
                        case 'jiso': return 4;
                        default: return 0; // Fallback to Blackpink
                    } })()]
                : miniGameLeaderData[idolNameFocus] && 
                miniGameLeaderData[idolNameFocus].memberId.toUpperCase()
                }
              </h2>

            </Col>
          </Row>
        </Container>
      </div>


      <div className='mini-game-idol-dance-btn-stats-wrap'>
        { miniGameLeaderData.length > 0 &&
          <Swiper
          onSwiper={setSwiperRef}
          slidesPerView={3}
          centeredSlides={true}
          // spaceBetween={30}
          // loop={true}
          loop={miniGameLeaderData.length > 3 ? true : false}
          // loopedSlides={2}
          // navigation={true}
          // modules={[Pagination, Navigation]}
          // pagination={{
          //   type: 'fraction',
          // }}
          // modules={[Navigation]}
          onSlideChange={() => {
            if (swiperRef) {
              // console.log(swiperRef)
              setIdolNameFocus(swiperRef.realIndex)
            }
          }}
          // onClick={() => {
          //   if (swiperRef) {
          //     console.log("onClick + realIndex = " +swiperRef.realIndex)
          //     // setIdolNameFocus(swiperRef.realIndex)
          //   }
          // }}
          className="mySwiper"
        >
          { miniGameLeaderData && 
          miniGameLeaderData.map((person, index) => (
            <SwiperSlide key={index} virtualIndex={index}>
              <div className='mini-game-idol-dance-wrap-imgs mx-auto d-block'>
                {/* <img className="img-full-width" src={ */}
                <img className="mini-game-idol-dance-wrap-slide-imgs" src={ matchIdolPoseImg(person.memberId) } 
                alt={person.name} />
              </div>
              </SwiperSlide>
          ))
          }
        </Swiper>
        }
        <div className='mini-game-idol-dance-wrap-btn-stats'>
          <Container>
            <Row className=''>
              <Col className="">
                <p className='mini-game-idol-dance-wrap-btn-stats-title'>{t('miniGameTitleSwipe')}</p>
                <Button size="lg" className='blink w-100' title='Play game' onClick={() => {
                  playBtnOnClick()
                }}>
                  {t('miniGameBtnPlayNow')}
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className='preload-display-none'>
        <img className="mini-game-idol-dance-wrap-slide-imgs" src={lisaPoseIdol01} />
        <img className="mini-game-idol-dance-wrap-slide-imgs" src={rosePoseIdol01} />
        <img className="mini-game-idol-dance-wrap-slide-imgs" src={jenniePoseIdol01} />
        <img className="mini-game-idol-dance-wrap-slide-imgs" src={jisooPoseIdol01} />
        <img className="mini-game-idol-dance-wrap-slide-imgs" src={BPPoseIdol01} />
      </div>

      
    </div>
  );

}

